module.exports = {
    language: {
        name: 'cn'
    },
    search:{
    	placeholder:'搜索',
    	btn:'搜索'
    },
     nav: {
        about:'关于佳期',
        story:'一「期」一故事',
        occupation:'职业发展',
        positions:'开放岗位',
        careers:'校园招聘',
        product:'旗下产品',
        responsibility:'社会责任',
        contact:'联系我们',
    },
    home:{
    	section1:'佳期投资',
    	more:'了解更多',
    	story:'一「期」一故事',
    	storySub:'带你走进Quant的世界',
    	responsibility:'佳期社会责任',
    	occupation:'职业发展',
    	occupationSub:'期待你加入佳期宇宙',
    },
    story:{
        banner:'一「期」一故事',
        bannerSub:'佳期人物志，发现那些有趣的灵魂',
        more:'查看详情',
    },
    about:{
        about:'关于佳期',
        story:'一「期」一故事',
        stroySub:'佳期人物志，发现那些有趣的灵魂',
        more:'了解更多',
        facts:'数说佳期',
        work:'工作在佳期'
    },
    responsibility:{
    	banner:'佳期社会责任',
        bannerSub:'共创更好未来',
    },
    occupation:{
        bannerTxt:'佳期，拥抱每一种可能',
        findJod:'立即查看岗位',
        openPosition:'热招岗位',
        schoolTxt:'校园活动',
        more:'查看详情',
        activity:'佳期校园活动',
        school:'2022年校园招聘',
        schoolSub:'寻找佳期宇宙的新星',
        winnerCap:'冬令营',
        winnerCapSub:'提前发现浩瀚的投资宇宙',
        hope:'敬请期待',
        jiayouzhan:'佳油站',
    },
    code:{
    	welcome:'更多动态与招聘信息，',
    	jiaqi:'佳期人才伙伴',
    	contact:'欢迎添加',
    	send:'也可以通过邮箱联系我们',
    },
    socialPost:{
        banner:'开放岗位',
        look:'目前正在寻找这些类型的角色',
        placeholder:'请选择'
    },
    socialDetail:{
        title:'开放岗位',
        introduce:'岗位介绍',
        requetion:'岗位要求',
        location:'工作地点',
        send:'请投递简历至邮箱',
        format:'标题格式：姓名-投递职位-工作年限。注意投递职位为',
        submit:'立即申请',
        tip1:'应聘方式:请投递简历与求职信至邮箱',
        tip2:'邮件主题及简历命名格式"岗位+',
        tip3:'+全职/实习+姓名+招聘信息来源"',
        mode:'应聘方式',
    },
    productIndex:{
        userName:'用户名',
        userNamePlaceholder:'请输入用户名',
        userNameFindPlaceholder:'请输入你要找回的用户名',
        password:'密码',
        passwordPlaceholder:'请输入密码',
        loginNow:'立即登录',
        forget:'忘记密码',
        bindEmail:'绑定邮箱',
        bindEmailPlaceholder:'请输入绑定邮箱地址',
        bindPhone:'绑定手机',
        bindPhonePlaceholder:'请输入绑定手机号码',
        sendEmail:'发送邮件',
        phone:'手机',
        phonePlaceholder:'请输入手机号码',
        code:'验证码',
        codePlaceholder:'验证码',
        sendCode:'发送验证码',
        newPassword:'新密码',
        newPasswordPlaceholder:'请输入新密码',
        confirmPassword:'修改密码',
        confrimAgain:'请再次输入新密码',
        agreement:'合格投资者认定',
        userLogin:'用户登录',
        findPhone:'通过绑定手机号码找回',
        findEmail:'通过绑定邮箱找回',
    },
    productList:{
        bannerTxt:'佳期旗下产品',
    },
    contact:{
        china:'北京',
        shanghai:'上海'
    },
    questionnaire:{
        title:'问卷调查',
        subTitle:'感谢您的提交',
        placeholder:'请选择问卷类型后答题',
        submit:'提交',
        result:'问卷结果',
    },
    privacyPolicy:{
        agreement:'隐私政策',
        determine:'我已知悉'
    }
}